module.exports = __webpack_public_path__ + "static/media/branch-juice.3816dba5.jpg";